import * as React from 'react'
import { UprightStyle } from '../types'

const logoStyle: UprightStyle = {
  default: {
    height: import.meta.env.MODE === 'development' ? '38px' : '27px',
    width: '119px',
    marginRight: '3px',
    marginTop: '1px',
    paddingLeft: '12px',
    verticalAlign: 'middle'
  }
}

export const logoForEnv = nodeEnv => {
  return nodeEnv === 'development' ? '/logos/upright-logo-development.svg' : '/logos/upright-logo-orange.svg'
}

const Logo = () => {
  return <img src={logoForEnv(import.meta.env.MODE)} alt="Upright Logo" style={logoStyle.default} />
}

export default Logo
